import { c as _c } from "react/compiler-runtime";
import { DateRangePicker, Tooltip, getDate } from '@systemeio/ui';
import { CONTACT_API } from 'modules/contacts/api/contact-api';
import { ContactTagsActionEnum } from 'modules/contacts/contact-page/enums/contact-tags-enum';
import { useContactTags } from 'modules/contacts/contact-page/hooks/use-contact-tags';
import { ContactPageFilterInterface } from 'modules/contacts/contact-page/types/contact-page-filter-interface';
import { ContactTagsInterface } from 'modules/contacts/contact-page/types/contact-tags-interface';
import { ContactId, ContactInterface } from 'modules/contacts/types/contact-interface';
import React, { useEffect } from 'react';
import ListingLayout from 'shared/components/listing-layout';
import { Table } from 'shared/components/table/table';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useUpdateData } from 'shared/hooks/use-update-data';
import useUser from 'shared/hooks/use-user';
import { useFilterPagination } from 'shared/route-query/hooks/use-filter-pagination';
import { OrderEnum } from 'shared/types/pagination-interface';
import { dateFormat, dateTimeFormat } from 'shared/utils/date-time-format';
import { getDateRangeSinceDate, getToday } from 'shared/utils/get-dates';
interface ContactTagsProps {
  contactId: ContactId;
  contact?: ContactInterface;
  shouldUpdateTags: boolean;
}
const defaultFilters: ContactPageFilterInterface = {
  date: [null, null]
};
const ContactTags = t0 => {
  const $ = _c(94);
  const {
    contactId,
    contact,
    shouldUpdateTags
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    user,
    intlLocale
  } = useUser();
  const {
    setPagination,
    pagination,
    setLimit,
    limit,
    filter,
    setFilter
  } = useFilterPagination(defaultFilters, true);
  const t1 = `${CONTACT_API}/contacts/${contactId}/tags`;
  const t2 = `${CONTACT_API}/contacts/${contactId}/tags`;
  let t3;
  if ($[0] !== setPagination || $[1] !== t1 || $[2] !== t2) {
    t3 = {
      api: t1,
      customApi: t2,
      setPagination
    };
    $[0] = setPagination;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const updateTagData = useUpdateData(t3);
  const t4 = filter.date[0] !== null;
  let t5;
  if ($[4] !== contactId || $[5] !== filter || $[6] !== limit || $[7] !== pagination || $[8] !== t4) {
    t5 = {
      contactId,
      limit,
      pagination,
      filter,
      shouldFetch: t4
    };
    $[4] = contactId;
    $[5] = filter;
    $[6] = limit;
    $[7] = pagination;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const {
    contactTags
  } = useContactTags(t5);
  let t6;
  let t7;
  if ($[10] !== contactTags || $[11] !== shouldUpdateTags || $[12] !== updateTagData) {
    t6 = () => {
      if (shouldUpdateTags) {
        updateTagData(true, contactTags);
      }
    };
    t7 = [contactTags, shouldUpdateTags, updateTagData];
    $[10] = contactTags;
    $[11] = shouldUpdateTags;
    $[12] = updateTagData;
    $[13] = t6;
    $[14] = t7;
  } else {
    t6 = $[13];
    t7 = $[14];
  }
  useEffect(t6, t7);
  let t8;
  if ($[15] !== contact || $[16] !== setFilter || $[17] !== user?.timezone) {
    t8 = () => {
      if (contact) {
        setFilter({
          date: getDateRangeSinceDate(contact.createdAt, user?.timezone)
        });
      }
    };
    $[15] = contact;
    $[16] = setFilter;
    $[17] = user?.timezone;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const t9 = user?.timezone;
  let t10;
  if ($[19] !== contact || $[20] !== setFilter || $[21] !== t9) {
    t10 = [contact, setFilter, t9];
    $[19] = contact;
    $[20] = setFilter;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  useEffect(t8, t10);
  let t11;
  if ($[23] !== t) {
    t11 = t("dashboard.contact_page.tag");
    $[23] = t;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t11) {
    t12 = {
      key: "tag",
      header: t11,
      widthPercent: 50,
      onRender: _temp
    };
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t) {
    t13 = t("global.action");
    $[27] = t;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t) {
    t14 = tag_0 => <span>{t(ContactTagsActionEnum[tag_0.action])}</span>;
    $[29] = t;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t13 || $[32] !== t14) {
    t15 = {
      key: "tag_action",
      header: t13,
      widthPercent: 30,
      onRender: t14
    };
    $[31] = t13;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t) {
    t16 = t("global.date");
    $[34] = t;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== user?.dateFormat || $[37] !== user?.timeFormat || $[38] !== user?.timezone) {
    t17 = tag_1 => <Tooltip wrapperClassName="w-full" mode="hover" label={dateTimeFormat(tag_1.date, {
      timeFormat: user?.timeFormat,
      dateFormat: user?.dateFormat,
      timeZone: user?.timezone
    })}><span className="w-full truncate">{dateFormat(tag_1.date, {
          dateFormat: user?.dateFormat,
          timeZone: user?.timezone
        })}</span></Tooltip>;
    $[36] = user?.dateFormat;
    $[37] = user?.timeFormat;
    $[38] = user?.timezone;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== t || $[41] !== user?.dateFormat || $[42] !== user?.timeFormat || $[43] !== user?.timezone) {
    t18 = tag_2 => <div className="flex items-center gap-3"><span className="text-text-primary font-bold">{t("global.date")}</span><span>{dateTimeFormat(tag_2.date, {
          timeFormat: user?.timeFormat,
          dateFormat: user?.dateFormat,
          timeZone: user?.timezone
        })}</span></div>;
    $[40] = t;
    $[41] = user?.dateFormat;
    $[42] = user?.timeFormat;
    $[43] = user?.timezone;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  let t19;
  if ($[45] !== t16 || $[46] !== t17 || $[47] !== t18) {
    t19 = {
      key: "date",
      header: t16,
      widthPercent: 20,
      onRender: t17,
      onRenderSmall: t18
    };
    $[45] = t16;
    $[46] = t17;
    $[47] = t18;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  let t20;
  if ($[49] !== t12 || $[50] !== t15 || $[51] !== t19) {
    t20 = [t12, t15, t19];
    $[49] = t12;
    $[50] = t15;
    $[51] = t19;
    $[52] = t20;
  } else {
    t20 = $[52];
  }
  const columns = t20;
  let t21;
  if ($[53] !== t) {
    t21 = t("dashboard.contact_page.tag_history");
    $[53] = t;
    $[54] = t21;
  } else {
    t21 = $[54];
  }
  let t22;
  if ($[55] !== t21) {
    t22 = <span className="text-[17px]">{t21}</span>;
    $[55] = t21;
    $[56] = t22;
  } else {
    t22 = $[56];
  }
  const t23 = user?.timezone;
  let t24;
  if ($[57] !== t23) {
    t24 = getToday(t23);
    $[57] = t23;
    $[58] = t24;
  } else {
    t24 = $[58];
  }
  const t25 = contact?.createdAt;
  const t26 = user?.timezone;
  let t27;
  if ($[59] !== t25 || $[60] !== t26) {
    t27 = getDate(t25, t26);
    $[59] = t25;
    $[60] = t26;
    $[61] = t27;
  } else {
    t27 = $[61];
  }
  let t28;
  if ($[62] !== contact?.createdAt || $[63] !== user?.timezone) {
    t28 = () => getDateRangeSinceDate(contact?.createdAt, user?.timezone);
    $[62] = contact?.createdAt;
    $[63] = user?.timezone;
    $[64] = t28;
  } else {
    t28 = $[64];
  }
  let t29;
  if ($[65] !== setFilter || $[66] !== setLimit || $[67] !== setPagination) {
    t29 = date => {
      setPagination({
        startFromId: undefined,
        order: OrderEnum.next
      });
      setLimit(10);
      setFilter({
        date
      });
    };
    $[65] = setFilter;
    $[66] = setLimit;
    $[67] = setPagination;
    $[68] = t29;
  } else {
    t29 = $[68];
  }
  const t30 = user?.timezone;
  const t31 = user?.createdAt;
  let t32;
  if ($[69] !== filter.date || $[70] !== intlLocale || $[71] !== t24 || $[72] !== t27 || $[73] !== t28 || $[74] !== t29 || $[75] !== t30 || $[76] !== t31) {
    t32 = <DateRangePicker maxDate={t24} minDate={t27} getDefaultDate={t28} date={filter.date} onChange={t29} timezone={t30} createdAt={t31} intlLocale={intlLocale} />;
    $[69] = filter.date;
    $[70] = intlLocale;
    $[71] = t24;
    $[72] = t27;
    $[73] = t28;
    $[74] = t29;
    $[75] = t30;
    $[76] = t31;
    $[77] = t32;
  } else {
    t32 = $[77];
  }
  let t33;
  if ($[78] !== limit || $[79] !== setLimit) {
    t33 = {
      limit,
      setLimit
    };
    $[78] = limit;
    $[79] = setLimit;
    $[80] = t33;
  } else {
    t33 = $[80];
  }
  let t34;
  if ($[81] !== pagination || $[82] !== setPagination) {
    t34 = {
      pagination,
      setPagination
    };
    $[81] = pagination;
    $[82] = setPagination;
    $[83] = t34;
  } else {
    t34 = $[83];
  }
  let t35;
  if ($[84] !== columns || $[85] !== contactTags || $[86] !== t33 || $[87] !== t34) {
    t35 = <Table limiter={t33} paginator={t34} data={contactTags} columns={columns} />;
    $[84] = columns;
    $[85] = contactTags;
    $[86] = t33;
    $[87] = t34;
    $[88] = t35;
  } else {
    t35 = $[88];
  }
  let t36;
  if ($[89] !== contactTags || $[90] !== t22 || $[91] !== t32 || $[92] !== t35) {
    t36 = <ListingLayout counter={false} data={contactTags} type="default" title={t22} customHeaderElement={t32}>{t35}</ListingLayout>;
    $[89] = contactTags;
    $[90] = t22;
    $[91] = t32;
    $[92] = t35;
    $[93] = t36;
  } else {
    t36 = $[93];
  }
  return t36;
};
export default ContactTags;
function _temp(tag) {
  return <Tooltip wrapperClassName="w-full" mode="overflow" label={tag.tag.name}>{tag.tag.name}</Tooltip>;
}